query(
    $filter: MarketGroupFilter
) {
  marketGroups: allMarketGroups(
    orderBy: POSITION_ASC
    filter: $filter
) {
    nodes {
      code
      displayName
      markets: marketGroupMarketCodesByMarketGroupId {
        nodes {
          marketCode
        }
      }
    }
  }
}
